import { modelOptions, prop } from '@typegoose/typegoose';
import * as mongoose from 'mongoose';

export class RemoteShellArchiveStatus {
  static NOT_UPLOADED = 1;
  static ERROR = 2;
  static UPLOADED = 3;
}

export class RemoteShellSessionLogStatus {
  static SESSION_STARTED_SUCCESSFULLY_LOGGED = 1;
  static SESSION_LOG_ERROR = 2;
  static SESSION_END_SUCCESSFULLY_LOGGED = 3;
}

@modelOptions({ schemaOptions: { _id: false } })
class RemoteShellSessionsRights {
  @prop({ required: false })
  manageCompanies: boolean;

  @prop({ required: false })
  manageInventory: boolean;

  @prop({ required: false })
  managePoliciesRead: boolean;

  @prop({ required: false })
  managePoliciesWrite: boolean;

  @prop({ required: false })
  manageUsers: boolean;

  @prop({ required: false })
  manageReports: boolean;

  @prop({ required: false })
  managePlatform: boolean;

  @prop({ required: false })
  companyManager: boolean;

  @prop({ required: false })
  manageRemoteShell: boolean;
}

@modelOptions({ schemaOptions: { _id: false } })
class RemoteShellSessionsRole {
  @prop({ required: false, type: mongoose.Schema.Types.ObjectId, default: null })
  roleId?: mongoose.Types.ObjectId | null;

  @prop({ required: false })
  name: string;

  @prop({ required: false })
  rights: RemoteShellSessionsRights;
}

@modelOptions({ schemaOptions: { _id: false } })
class RemoteShellSessionsUser {
  @prop({ required: false })
  id: mongoose.Types.ObjectId;

  @prop({ required: false })
  email: string;

  @prop({ required: false })
  userName: string;

  @prop({ required: false })
  role: RemoteShellSessionsRole;

  @prop({ required: false })
  companyId: mongoose.Types.ObjectId;

  @prop({ required: false })
  ip: string;

  @prop({ required: false })
  host: string;
}

@modelOptions({ schemaOptions: { _id: false } })
class RemoteShellSessionsDetails {
  @prop({ required: false })
  endpointName: string;

  @prop({ required: false })
  endpointType: number;

  @prop({ required: true })
  started: Date;

  @prop({ required: false })
  ended?: Date;

  @prop({ required: false })
  streamId?: string;
}

@modelOptions({ schemaOptions: { _id: false } })
class RemoteShellSessionsSpecifics {
  @prop({ required: true })
  user: RemoteShellSessionsUser;

  @prop({ required: true })
  details: RemoteShellSessionsDetails;
}

@modelOptions({ schemaOptions: { _id: false } })
class LogInformation {
  @prop({ required: true })
  status: number;

  @prop({ required: true })
  endSessionLastChecked: Date;
}

@modelOptions({ schemaOptions: { _id: false } })
export class StreamStatus {
  @prop({ required: true })
  exitCode: number;

  @prop({ required: false })
  errorCode?: number;

  @prop({ required: false })
  reasonCode?: number;
}

class RemoteShellArchive {
  @prop({ required: false, type: mongoose.Schema.Types.ObjectId, default: null })
  fileId?: mongoose.Types.ObjectId | null;

  @prop({ required: false, default: 0 })
  retries: number;

  @prop({ required: false, default: 1 })
  status: number;

  @prop({ required: false })
  deleted: Date;
}

export class RemoteShellSessionUser {
  @prop({ required: true })
  id: mongoose.Types.ObjectId;

  @prop({ required: true })
  name: string;
}

export class RemoteShellSessionEndpoint {
  @prop({ required: true })
  id: mongoose.Types.ObjectId;

  @prop({ required: true })
  name: string;
}

@modelOptions({ schemaOptions: { _id: false } })
class UploadedFile {
  @prop({ required: true })
  name: string;

  @prop({ required: false })
  id: mongoose.Types.ObjectId;
}

@modelOptions({ schemaOptions: { _id: false } })
class UploadedFiles {
  @prop({ required: true })
  path: string;

  @prop({ required: true, type: [UploadedFile] })
  files: Array<UploadedFile>;
}

@modelOptions({ schemaOptions: { _id: false } })
class DownloadedFile {
  @prop({ required: true })
  name: string;

  @prop({ required: false })
  path: string;
}

@modelOptions({ schemaOptions: { _id: false } })
class DownloadedFiles {
  @prop({ required: true })
  path: string;

  @prop({ required: true, type: [DownloadedFile] })
  files: Array<DownloadedFile>;
}

@modelOptions({
  schemaOptions: { collection: 'remoteShellSessions', versionKey: false, read: 'primary' },
  options: { customName: 'remoteShellSessions' },
})
export class RemoteShellSessions {
  @prop({ required: true, _id: false, type: RemoteShellSessionEndpoint })
  endpoint: RemoteShellSessionEndpoint;

  @prop({ required: true })
  companyId: mongoose.Types.ObjectId;

  @prop({ required: true, _id: false, type: RemoteShellSessionUser })
  user: RemoteShellSessionUser;

  @prop({ required: true })
  streamId: string;

  @prop({ required: true })
  connectionId: string;

  @prop({ required: true, _id: false, type: RemoteShellArchive })
  archive: RemoteShellArchive;

  @prop({ required: true })
  queueName: string;

  @prop({ required: true })
  log: LogInformation;

  @prop({ required: true })
  endSessionSpecifics: RemoteShellSessionsSpecifics;

  @prop({ required: true })
  created: Date;

  @prop({ required: true })
  updated: Date;

  @prop({ required: false })
  streamStatus: StreamStatus;

  @prop({ required: false, type: [UploadedFiles] })
  uploadedFiles: Array<UploadedFiles>;

  @prop({ required: false, type: [DownloadedFiles] })
  downloadedFiles: Array<DownloadedFiles>;
}
